// See also variables.less

export type AuthorisationColours = {
    primary: string;
    primaryLight: string;
    primary8: string;
    info: string;
    primaryPale: string;
    tertiary: string;
};

export function overrideAuthorisationColours(colours: AuthorisationColours) {
    primary = colours.primary;
    primaryLight = colours.primaryLight;
    primary8 = colours.primary8;
    info = colours.info;
    primaryPale = colours.primaryPale;
    tertiary = colours.tertiary;
}

export let primary = '#006AD2';
export let primaryLight = '#0070ec';
export let primary8 = '#ebf3fb';
export let info = '#0099ff';
export let primaryPale = '#daebfe';
export let tertiary = '#001e82';

// White/Black/Grey
export const heading = '#202020';
export const body = '#707070';
export const iconLight = '#aaa';
export const divider = '#d2d2d2';
export const backgroundAlt = '#f5f5f5';
export const white = '#fff';
export const black = '#000';
export const white50 = 'rgba(255,255,255,0.5)';

export const success = '#ebf8eb';

export const infoGlow = '#ebf7ff';
export const infoGlowBorder = '#09f';
export const infoGlowText = '#0074c2';

export const successGlow = '#ebf8eb';
export const successGlowBorder = '#00ac00';
export const successGlowText = '#008000';

export const errorText = '#c53535';

export const errorGlow = '#f9ebeb';
export const errorGlowBorder = '#c53535';
export const errorGlowText = '#c53535';

export const warningGlow = '#fef6e9';
export const warningGlowBorder = '#f5a623';
export const warningGlowText = '#8e5a06';
export const warningGlowAccessible = '#925d07';

// Button variants
export const accentVariant = '#001e82';
export const infoVariant = '#09f';
export const successVariant = '#00ac00';
export const dangerVariant = '#c53535';
export const warningVariant = '#8e5a06';
export const headingVariant = '#202020';
export const lightVariant = '#fff';
export const altVariant = '#f5f5f5';

// Other colours
export const red = '#d0011b';
export const orange = '#f5a623';
export const green = '#00ac00';
export const babyBlue = '#6CA1E3';

// Avatar colours
export const avatarColours = [
    '#E91E63',
    '#9C26B0',
    '#4051B5',
    '#2196F3',
    '#00BCD4',
    '#4BAF50',
    '#8BC34A',
    '#FFC10A',
    '#FF9802',
    '#FF5722',
    '#795548',
    '#9E9E9E',
    '#607D8B'
];

// medication card
export const medicationStopped = '#aaa';
export const medicationExpired = '#c53535';
export const medicationAboutToExpireIcon = '#f5a623';
export const medicationAboutToExpireText = '#925d07';
export const expiredRowIcon = '#c53535';
export const warningRowIcon = '#f5a623';
